import type { FC } from "react"

import type { PastChallenges as TPastChallenges } from "../../api/hooks/past"
import type { TPagination } from "../@shared"
import { Footer, Header, Listing, Search } from "./components"

interface Props {
	loading: boolean
	challenges: TPastChallenges
	pagination: TPagination
}

export const PastChallenges: FC<Props> = ({
	challenges,
	loading,
	pagination,
}) => (
	<>
		<Header />
		<Search />
		<Listing loading={loading} challenges={challenges} />
		<Footer pagination={pagination} />
	</>
)
